<template>
  <div class="docs">
    <div class="docs_area">
      <h1 style="border-bottom: 1px solid">Documents</h1>

      <div v-for="doc in documents" style="margin-top: 30px" :key="doc.id">
        <h3 style="color: darkred">{{ doc.file_name }}</h3>
        <div style="margin-left: 20px">
          <div v-for="f in doc.files" :key="f.id">
            <div class="content">
              <div class="header">
                <i class="pdf red file icon"></i>
                <a :href="f.download_link">{{
                  f.file_name
                  }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "documents",
  data() {
    return {
      loading: false,
      documents: [],
    };
  },
  created() {
    this.loading = true;
    this.$axios
      .get(`/data/documents`)
      .then((r) => {
        if (r.status === 200) {
          this.documents = r.data;
        }
      })
      .catch((_) => { })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
<style media="screen">
.docs_area {
  padding: 80px 20px 0 100px;
}
</style>
